/** Explicit types take precedence; legacy untyped rows may use their title. */
export function isPerformanceVideo(video: {
  video_type?: string | null;
  title?: string | null;
}) {
  const type = video.video_type?.trim().toLowerCase();
  if (type)
    return ["performance", "final", "final video", "full performance"].includes(
      type,
    );
  const title = video.title ?? "";
  return (
    !/\b(preview|tutorial)\b/i.test(title) &&
    /\b(performance|final)\b/i.test(title)
  );
}

export function performanceVimeoEmbed(
  value: string | null | undefined,
): string | null {
  try {
    const url = new URL(value ?? "");
    if (
      !["vimeo.com", "www.vimeo.com", "player.vimeo.com"].includes(url.hostname)
    )
      return null;
    const match = url.pathname.match(
      /^\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?\/?$/,
    );
    if (!match) return null;
    const embed = new URL(`https://player.vimeo.com/video/${match[1]}`);
    const hash = match[2] ?? url.searchParams.get("h");
    if (hash) embed.searchParams.set("h", hash);
    embed.searchParams.set("autopause", "1");
    return embed.href;
  } catch {
    return null;
  }
}
